import theme from './theme';
import './fonts.css';
import { LanguageProvider, useLanguage } from "./LanguageContext";
import banner from './img/banner.png';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams, useNavigate, useLocation } from 'react-router-dom';
import NavigationBar from './navigation/NavigationBar';
import Footer from "./navigation/Footer";
import { ThemeProvider } from '@mui/material/styles';
import { useMediaQuery, Box } from '@mui/material';
import Home from './pages/Home';
import { ProgramDE, ProgramHU, ProgramUS } from './pages/program/Program';
//import Speakers from './pages/program/Speakers';
//import Sponsors from './pages/Sponsors';
//import Register from './pages/register/Register';
//import UnderDevelopment from './pages/UnderDev';
//import CallForPaper from './pages/program/CallForPaper';
import Deadlines from './pages/Deadlines';
import Host from './pages/Hosts';
//import EndRegister from './pages/register/EndRegister';
//import NewsWall from './pages/News';
import Contact from './pages/Contact';
import Gallery from './pages/Gallery';
import PublicationsWall from './pages/Publications';

const captionExhibit = {
  captionEn: "We are currently finalizing the list of speakers and exhibitors.",
  captionHu: "Jelenleg az előadók és kiállítók kiválasztása folyik."
}

const captionSponsor = {
  captionEn: "We are currently finalizing the list of sponsors.",
  captionHu: "Jelenleg a szponzorok listájának véglegesítése folyik."
}

const captionFAQ = {
  captionEn: "We are currently organising the event. Frequently Asked Questions will be published soon.",
  captionHu: "Jelenleg az esemény szervezésén dolgozunk. A Gyakran Ismételt Kérdéseket hamarosan közzétesszük."
}

const captionMedia = {
  captionEn: "We are currently organising the event. Photos and videos will be available after the conference.",
  captionHu: "Jelenleg az esemény szervezésén dolgozunk. A fotók és videók a konferencia után lesznek közzétéve."
}

// Language-aware wrapper for routes
function LanguageRoutes({ isMobile }: { isMobile: boolean }) {
  const { language } = useLanguage();
  const location = useLocation();

  const params = useParams<{ lang: string }>();
  const lang = params.lang;

  if (lang && lang !== language) {
    // Sync the language context with the URL parameter
    console.log(`Language mismatch detected. Current: ${language}, URL: ${lang}`);
  }

  return (
    <Routes>
      <Route path="/:lang" element={<Navigate to={`/${lang}/home`} replace />} />
      <Route path="/:lang/home" element={<Home isMobile={isMobile} />} />
      <Route path="/:lang/hungarian-program" element={<ProgramHU />} />
      <Route path="/:lang/german-program" element={<ProgramDE />} />
      <Route path="/:lang/english-program" element={<ProgramUS />} />
      {/*<Route
        path="/:lang/speakers-exhibitors"
        element={<Speakers />}
      />
      <Route
        path="/:lang/sponsors"
        element={<UnderDevelopment captionEn={captionSponsor.captionEn} captionHu={captionSponsor.captionHu} />}
      />*/}
      <Route
        path="/:lang/deadlines"
        element={<Deadlines />}
      />
      <Route
        path="/:lang/host"
        element={<Host />}
      />
      <Route
        path="/:lang/contact"
        element={<Contact />}
      />
      <Route
        path="/:lang/gallery"
        element={<Gallery />}
      />
      {/*<Route
        path="/:lang/news"
        element={<NewsWall />}
        //element={<UnderDevelopment captionEn={captionMedia.captionEn} captionHu={captionMedia.captionHu} />}
      />*/}
      <Route
        path="/:lang/publications"
        element={<PublicationsWall />}
        //element={<UnderDevelopment captionEn={captionMedia.captionEn} captionHu={captionMedia.captionHu} />}
      />
      {/*<Route path="/:lang/register" element={<Register />} />
      <Route path="/:lang/register" element={<EndRegister />} />
      <Route path="/:lang/call-for-paper" element={<CallForPaper />} />*/}
      <Route path="*" element={<Navigate to={`/${language}/home`} replace />} />
    </Routes>
  );
}

export default function App() {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <ThemeProvider theme={theme}>
      <Router>
        <LanguageProvider>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              backgroundImage: `url(${banner})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              minHeight: '50vh',
            }}
          >
            <NavigationBar isMobile={isMobile} />
            <Box sx={{ flex: 1 }}>
              <LanguageRoutes isMobile={isMobile} />
            </Box>
            <Footer />
          </Box>
        </LanguageProvider>
      </Router>
    </ThemeProvider>
  );
}
